import classNames from 'classnames'
import { type ComponentChild, h, JSX } from 'preact'

export interface RadioInputProps {
    modifier?: string
    class?: string
    label: ComponentChild
    isChecked?: boolean
    name?: string
    id: string
    onClick?: () => void
}

export const RadioInput = (props: RadioInputProps): JSX.Element => {
    const className: string = classNames(
        'radio-input',
        props.modifier,
        props.class,
        props.isChecked && 'is-checked',
    )

    return (
        <label htmlFor={props.id} className={className}>
            <input
                className="radio-input__input"
                type="radio"
                id={props.id}
                name={props.name}
                checked={props.isChecked}
                onClick={props.onClick}
            />
            <span class="radio-input__box" />
            <span class="radio-input__label">{props.label}</span>
        </label>
    )
}
